import { MenuToggleContext } from '@/base/layouts/contexts/MenuToggleContext';
import { useEditorStore } from '@/editor/store/editorStore';
import { useContext } from 'react';
import {
  Puller,
  PullerWrapper,
  SwipeableWrapper
} from './InferiorMenuDrawer.styles';

export const inferiorDrawerBleeding = 12;

export const InferiorMenuDrawer = ({ children, isEditor }) => {
  const { isMenuOpen, closeMenu, toggleMenu } = useContext(MenuToggleContext);
  const { setIsLogoCustomizationPreview } = useEditorStore();

  return (
    <div>
      <SwipeableWrapper
        transitionDuration={300}
        anchor="bottom"
        open={isMenuOpen}
        onClose={() => {
          setIsLogoCustomizationPreview(false);
          closeMenu();
        }}
        onOpen={toggleMenu}
        swipeAreaWidth={inferiorDrawerBleeding}
        disableSwipeToOpen={false}
        sx={{
          flexShrink: isEditor && isMenuOpen && 0,
          [`& .MuiDrawer-paper`]: {
            marginBottom: isEditor && isMenuOpen && 8,
            top: isEditor && isMenuOpen && 100
          }
        }}
      >
        <PullerWrapper>
          <Puller />
        </PullerWrapper>
        {children}
      </SwipeableWrapper>
    </div>
  );
};
